import * as React from 'react';

import {SUPPORT_EMAIL} from '../../constants';
import {Link} from './Link';

// Makes the support email tappable wherever a message mentions it.
export function withSupportEmailLink(message: string): React.ReactNode {
  const [before, after] = message.split(SUPPORT_EMAIL);
  if (after === undefined) {
    return message;
  }
  return (
    <>
      {before}
      <Link
        href={`mailto:${SUPPORT_EMAIL}`}
        className="cursor-pointer font-semibold underline hover:opacity-70">
        {SUPPORT_EMAIL}
      </Link>
      {after}
    </>
  );
}
